import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientChildIssueList = createAsyncThunk("client/list-child-issue", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/list-child-issue`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.clientChildIssue);
    return res.data.clientChildIssue;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client child issues");
  }
});

export const getServiceTypes = createAsyncThunk(
  "provider/get-service-types",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/provider/get-service-type`);
      return res.data.service_type;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch service types");
    }
  }
);

export const addClientChildIssue = createAsyncThunk("client/add-child-issue", async ({ token, formData }, thunkAPI) => {
  try {
      const res = await axios.post(
        `${BACKEND_URL}/client/add-child-issue`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to add client child issues");
  }
});

export const updateClientChildIssue = createAsyncThunk(
  "client/update-child-Issue",
  async ({ token, formData, issueId }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/client/update-child-Issue/${issueId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update client child issues"
      );
    }
  }
);

export const deleteClientChildIssue = createAsyncThunk(
  "client/delete-child-Issue",
  async ({ token, IssueId  }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/client/delete-child-Issue/${IssueId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete client child issues"
      );
    }
  }
);

const clientChildIssueSlice = createSlice({
  name: "clientChildIssue",
    initialState: {
      clientsChildIssue: null,
      serviceTypes: [],
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientChildIssueList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientChildIssueList.fulfilled, (state, action) => {
            state.clientsChildIssue = action.payload;
            state.loading = false;
        })
        .addCase(getClientChildIssueList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client child issues"; 
            state.loading = false;
        })
        .addCase(getServiceTypes.fulfilled, (state, action) => {
          state.serviceTypes = action.payload;
        })
        .addCase(getServiceTypes.rejected, (state, action) => {
          state.error = action.payload;
        })
        .addCase(addClientChildIssue.pending, (state) => {
          state.loading = true;
        })
        .addCase(addClientChildIssue.fulfilled, (state, action) => {
          state.clientsChildIssue = action.payload.clientChildIssue;
          state.loading = false;
        })
        .addCase(addClientChildIssue.rejected, (state, action) => {
          state.error = action.payload || "Failed to add client child issue";
          state.loading = false;
        })
        .addCase(deleteClientChildIssue.pending, (state) => {
          state.loading = true;
        })
        .addCase(deleteClientChildIssue.fulfilled, (state, action) => {
          state.loading = false;
        })
        .addCase(deleteClientChildIssue.rejected, (state, action) => {
          state.error = action.payload || "Failed to delete client child issues";
          state.loading = false;
        })
    }
});

export default clientChildIssueSlice.reducer;